import React, { useEffect, useState } from 'react';

import { useGetLists, useGetListsCount } from '@vlabs/api/artemy/client';
import { PageSubheader } from '@vlabs/monokit/shared/ui/page';
import { PaginationPanel } from '@vlabs/uikit';
import { useTranslation } from 'react-i18next';

import { ListListTable } from './list-list-table';
import st from './ListListViewer.module.sass';
import { ListListPageFastFilters } from '../filters';
import { useListListPageFilters } from '../useListListPageFilters';

export function ListListViewer(): React.JSX.Element {
  const { t } = useTranslation();
  const { filters, updateFilters } = useListListPageFilters();
  const [selectedIds, setSelectedIds] = useState<Record<string, boolean>>({});
  const getLists = useGetLists(filters);
  const getListsCount = useGetListsCount(filters);

  useEffect(() => setSelectedIds({}), [getLists.data]);

  return (
    <React.Fragment>
      <PageSubheader
        className={st.Subheader}
        title={(
          <div className={st.Title}>
            {t('list-list-page:lists_found', { count: getListsCount?.data?.lists_count ?? 0 })}
          </div>
        )}
      >
        <div className={st.SubheaderContent}>
          <div className={st.SubheaderFastFilters}>
            <ListListPageFastFilters />
          </div>
        </div>
      </PageSubheader>

      <div className={st.Root}>

        <ListListTable
          data={getLists.data?.lists ?? []}
          onSelect={setSelectedIds}
          selectedIds={selectedIds}
        />

        <div className={st.Pagination}>
          <PaginationPanel
            canNextPage={(getLists?.data?.lists?.length ?? 0) >= (filters.page_size ?? 0)}
            canPreviousPage={(filters?.page ?? 0) > 0}
            gotoPage={(page) => updateFilters({ page: page + 1 })}
            nextPage={() => updateFilters({ page: (filters?.page ?? 0) + 1 })}
            pageCount={Math.ceil(((getListsCount?.data?.lists_count ?? 0) / (filters?.page_size ?? 25)))}
            pageIndex={(filters?.page ?? 1) - 1}
            pageSize={filters.page_size}
            previousPage={() => updateFilters({ page: (filters?.page ?? 0) - 1 })}
            setPageSize={(page_size: number) => updateFilters({ page_size })}
          />
        </div>
      </div>
    </React.Fragment>
  );
}
